import { ReviewStatus } from 'app/developer-v3/types/statuses';
import {
  isPublicIntentionElementVisible,
  sortVersionStrings,
} from 'app/developer-v3/utils';

import { SIDEBAR_ITEMS, VERSIONLESS_ROUTES } from './constants';
import { SidebarManageKey } from './types';

import type { SemVer } from 'app/developer-v3/types/version';

export function getVersionNumberAfter(appVersionNumber: string): string {
  const [major, minor, patch] = appVersionNumber.split('.');
  const nextPatchVersion = parseInt(patch, 10) + 1;
  const nextVersionNumber = `${major}.${minor}.${nextPatchVersion}`;
  return nextVersionNumber;
}

export function buildSidebarVersionDropdownItems(
  versions: SemVer[],
  currentVersion: SemVer
): Array<{ label: string; value: string }> {
  const items = sortVersionStrings(versions)
    .filter(version => version !== currentVersion)
    .map(version => ({ label: `Version ${version}`, value: version }))
    .slice(0, 5);

  items.push({ label: 'See all versions', value: 'all' });

  return items;
}

export function isVersionlessRoute(routeKey: string) {
  return VERSIONLESS_ROUTES.includes(routeKey);
}

type Options = {
  hasIssues: boolean;
  isNotAdmin: boolean;
  isPrivate: boolean;
  isPublicIntention: boolean;
  isPublished: boolean;
  isTeamEnabled: boolean;
  reviewStatus: ReviewStatus;
};

type SidebarItemHandlers = {
  [route: string]: (options: Options) => boolean;
};

const sidebarManageItemGetters: SidebarItemHandlers = {
  [SidebarManageKey.publishing]: function (options) {
    const ret = options.isPrivate
      ? isPublicIntentionElementVisible({
          isPrivate: options.isPrivate,
          isPublicIntention: options.isPublicIntention,
        })
      : options.reviewStatus === ReviewStatus.pushedBack;
    return ret;
  },
  [SidebarManageKey.issues]: function (options) {
    return options.isPublished || options.hasIssues;
  },
  [SidebarManageKey.monitoring]: function (options) {
    return !options.isNotAdmin;
  },
};

export function buildSidebarManage(options: Options) {
  return SIDEBAR_ITEMS.MANAGE.reduce((items, item) => {
    const getter = sidebarManageItemGetters[item.key];
    if (!getter || getter?.(options)) {
      items.push(item);
    }
    return items;
  }, []);
}
